// Caps the vertical thumbnail column (see component-product-hero.css,
// media-gallery[data-desktop-layout='thumbnail']) at the main image's real
// rendered height, so extra thumbnails scroll internally instead of
// stretching the column (and dragging the whole gallery) taller than the
// main image. Re-measures whenever the main image's size actually changes
// (resize, image load, variant switch) via ResizeObserver rather than only
// on window resize.
document.addEventListener('DOMContentLoaded', function () {
  var desktopQuery = window.matchMedia('(min-width: 1240px)');

  document.querySelectorAll("media-gallery[data-desktop-layout='thumbnail']").forEach(function (gallery) {
    var sliders = gallery.querySelectorAll(':scope > slider-component');
    if (sliders.length < 2) return;
    var mainSlider = sliders[0];
    var thumbSlider = sliders[1];

    function sync() {
      thumbSlider.style.maxHeight = desktopQuery.matches ? mainSlider.offsetHeight + 'px' : '';
    }

    new ResizeObserver(sync).observe(mainSlider);
    desktopQuery.addEventListener('change', sync);
    sync();

    // The theme's prev/next buttons only know how to scroll horizontally
    // (SliderComponent.onButtonClick uses scrollLeft) - add real vertical
    // paging on top of that for this column, and keep the buttons' disabled
    // state in sync with how far the list has actually scrolled.
    var list = thumbSlider.querySelector('.thumbnail-list');
    var prevBtn = thumbSlider.querySelector('button[name="previous"]');
    var nextBtn = thumbSlider.querySelector('button[name="next"]');
    if (!list || !prevBtn || !nextBtn) return;

    function pageAmount() {
      // Measured as the distance between item 1's and item 4's top edge,
      // rather than item.offsetHeight * 3, so the gap between thumbnails
      // (set in CSS) is naturally included instead of under-scrolling by
      // 3 gaps' worth each time.
      var items = list.querySelectorAll('.thumbnail-list__item');
      if (items.length > 3) return items[3].offsetTop - items[0].offsetTop;
      if (items.length > 0) {
        var gap = parseFloat(getComputedStyle(list).rowGap) || 0;
        return (items[0].offsetHeight + gap) * items.length;
      }
      return list.clientHeight;
    }

    function updateButtons() {
      // The base SliderComponent this <slider-component> already is also
      // listens for 'scroll' and sets the native `disabled` attribute
      // itself - but its isSlideVisible() check is written for horizontal
      // sliders (scrollLeft/offsetLeft/clientWidth), which is meaningless
      // here since this list never scrolls horizontally at all, so it ends
      // up marking BOTH buttons disabled and genuinely unclickable. Strip
      // that back off every time and apply our own vertical, scrollTop-
      // based check as a visual-only class instead.
      prevBtn.removeAttribute('disabled');
      nextBtn.removeAttribute('disabled');
      // Math.ceil, and a couple spare px of tolerance, because scrollTop
      // can land on a fractional/subpixel value that never quite reaches
      // scrollHeight exactly, leaving "next" permanently enabled.
      prevBtn.classList.toggle('is-disabled', list.scrollTop <= 0);
      nextBtn.classList.toggle('is-disabled', Math.ceil(list.scrollTop + list.clientHeight) >= list.scrollHeight - 2);
    }

    prevBtn.addEventListener('click', function () {
      list.scrollBy({ top: -pageAmount(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      list.scrollBy({ top: pageAmount(), behavior: 'smooth' });
    });
    list.addEventListener('scroll', updateButtons);
    updateButtons();

    // The base class also has its OWN ResizeObserver on this same list
    // (for its horizontal paging math), which re-fires - and re-adds
    // `disabled` - any time the list's size changes, including right after
    // our own max-height sync above resizes it. A plain one-time/scroll-
    // triggered fix can't win that race, so watch the attribute itself and
    // strip it back off immediately whenever anything else adds it back.
    var stripDisabled = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.target.hasAttribute('disabled')) mutation.target.removeAttribute('disabled');
      });
    });
    stripDisabled.observe(prevBtn, { attributes: true, attributeFilter: ['disabled'] });
    stripDisabled.observe(nextBtn, { attributes: true, attributeFilter: ['disabled'] });
  });
});
